/**
 * Dicas dos campos "A quem se destina" e "Temas abordados", espelhando como o site monta a seção
 * (site-abra-v2, `eventos/[slug]/components/target-and-topics`): cada item de lista ou parágrafo
 * vira um card/tópico, e o primeiro ": " (dois-pontos + espaço) separa o título do texto.
 * Rótulo só de números ("10: 30") não é separado, para não quebrar horário ao meio.
 *
 * Vale para o evento avulso e para a série — mudou no site, muda aqui.
 */
export const TARGET_AUDIENCE_HINT =
  'Cada linha vira um card no site. Para ter título e texto no card, separe com dois-pontos e espaço — ex.: "Pais e responsáveis: querem acompanhar a evolução dos filhos".'

export const TOPICS_HINT =
  'Cada linha vira um tópico no site. O que vier antes de dois-pontos e espaço fica em negrito — ex.: "Composição: como organizar os elementos na tela".'
